<template>
  <div class="input-group-prepend">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdInputGroupPrepend',

  inheritAttrs: false,

  emits: []
});
</script>
